import React from "react";
import { Link } from "react-router-dom";
import AppHeader from "@/components/drill/AppHeader";

const sections = [
  {
    id: "privacy",
    title: "Privacy Policy",
    body: [
      "Drill Log Pro collects and handles account, organisation, device, operational and support information needed to provide, secure and support the service.",
      "Personal information may include your name, email address, organisation membership, role, device information, authentication/session information and information contained in records created through Drill Log Pro.",
      "Information is used to provide the service, authenticate users, enforce organisation access controls, synchronise data, provide support, maintain security, prevent misuse and meet legal obligations.",
      "You may request access to or correction of personal information held about you, subject to applicable law. Privacy complaints can be raised with 2DudesTech PTY LTD through the support channel provided by your organisation or the Drill Log Pro website.",
      "Drill Log Pro may use third-party infrastructure providers to deliver the service. The final production privacy policy will identify relevant overseas disclosures and service providers once the production hosting regions are fixed."
    ]
  },
  {
    id: "terms",
    title: "Terms of Service",
    body: [
      "Drill Log Pro is a subscription software service provided by 2DudesTech PTY LTD.",
      "An organisation is responsible for maintaining authorised users, protecting account credentials and ensuring that information entered into the service is accurate and appropriate for its operational use.",
      "Subscription access is governed by the organisation's selected licence, including its active rig allowance, billing period and any applicable trial period.",
      "The 14-day trial provides one active rig, unlimited users and standard support. Trial access does not create an entitlement to a paid subscription after the trial expires.",
      "2DudesTech PTY LTD may suspend or restrict access where reasonably necessary for security, misuse, non-payment, breach of the applicable terms or legal compliance."
    ]
  },
  {
    id: "licence",
    title: "Licence Agreement",
    body: [
      "A Drill Log Pro licence grants the subscribing organisation a limited, non-exclusive right to use the service for its authorised business operations during the applicable subscription period.",
      "Fleet licences use marginal rig bands. Each active rig is charged according to the band it occupies. Users are not individually charged under the standard fleet plans.",
      "The organisation must not resell, sublicense or provide unauthorised third-party access to its Drill Log Pro tenant."
    ]
  },
  {
    id: "security",
    title: "Data & Security",
    body: [
      "Drill Log Pro uses organisation-level access controls and database security policies designed to isolate customer data between organisations.",
      "Organisation membership is authoritative for access. Revoking a user's membership removes their access to that organisation's protected data.",
      "The application is designed to prevent a user who moves from one Drill Log Pro organisation to another from retaining access to the previous organisation through the new organisation.",
      "Security controls include authentication, role-based access, tenant-aware synchronisation and database-level Row Level Security where the cloud backend is configured accordingly.",
      "Customers remain responsible for selecting appropriate users, protecting credentials and reporting suspected security incidents promptly."
    ]
  },
  {
    id: "company",
    title: "Company Information",
    body: [
      "Drill Log Pro is provided by 2DudesTech PTY LTD.",
      "The company's ABN and ACN are intentionally not hard-coded into this build because the authoritative registered identifiers were not supplied. They should be populated in the production billing/company configuration before commercial launch.",
      "Official company and product information: 2DudesTech website and Drill Log Pro product page."
    ]
  },
  {
    id: "opensource",
    title: "Open Source Licences",
    body: [
      "Drill Log Pro incorporates third-party open-source libraries. Their respective licences and notices form part of the applicable software notices for the distributed application.",
      "The production release process should generate and package the dependency licence notices from the exact dependency lockfile used for that release."
    ]
  }
];

export default function Legal() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <AppHeader title="Legal & Security" subtitle="Drill Log Pro information" backTo="/" />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 pb-24 space-y-4">
        <div className="rounded-xl border bg-white p-5 shadow-sm dark:bg-slate-900">
          <div className="text-sm font-semibold">Drill Log Pro by 2DudesTech PTY LTD</div>
          <p className="mt-1 text-xs text-muted-foreground">Legal, privacy, licensing and security information.</p>
        </div>
        {sections.map((section) => (
          <section id={section.id} key={section.id} className="scroll-mt-24 rounded-xl border bg-white p-5 shadow-sm dark:bg-slate-900">
            <h2 className="text-base font-semibold">{section.title}</h2>
            <div className="mt-3 space-y-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
              {section.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            </div>
          </section>
        ))}
        <div className="rounded-xl border bg-white p-5 shadow-sm dark:bg-slate-900">
          <h2 className="text-base font-semibold">Official links</h2>
          <div className="mt-3 flex flex-wrap gap-4 text-sm">
            <a className="text-primary hover:underline" href="https://www.2dudestech.com.au/pages/drill-log-pro" target="_blank" rel="noreferrer">Drill Log Pro website</a>
            <Link className="text-primary hover:underline" to="/tools/coming-soon-support">Support</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
